<template>
  <Map v-bind="$attrs" ref="map">
    <DatastoreDetailControlEdit
      v-if="datastoreDetail"
      :datastoreDetail="datastoreDetail"
      position="top-left"
      @click:select="onSelectMap"
      ref="DatastoreDetailControlEdit"
    />
    <BaseMapControl position="bottom-left" :baseMaps="baseMaps">
    </BaseMapControl>
    <!-- <HomeControl /> -->

    <BboxControl
      position="top-right"
      v-if="
        datastoreDetail &&
          datastoreDetail.meta &&
          datastoreDetail.meta.bbox_4326
      "
      :bbox="datastoreDetail.meta.bbox_4326"
    />
    <FullScreenControl position="top-right" />
    <ZoomControl position="top-right" />
    <MouseCoordinatesControl v-if="!isMobile" />
  </Map>
</template>

<script>
import {
  BaseMapControl,
  FullScreenControl,
  BboxControl,
  Map,
  MouseCoordinatesControl,
  ZoomControl,
} from '@components/Map'
import DatastoreDetailControlEdit from './datastore-detail-control-edit.vue'
import { API_BASEMAP, API_DATASTORE_DETAIL, API_FEATURE } from '@api'
import { ConfirmBuilder, replaceLink } from '@utils'
import { mapGetters } from 'vuex'
import { EDIT_TYPE } from '@constant'
import { BaseMapCreate } from '@/src/service/model/BaseMap'
export default {
  mixins: [],
  components: {
    Map,
    FullScreenControl,
    MouseCoordinatesControl,
    ZoomControl,
    BboxControl,
    BaseMapControl,
    DatastoreDetailControlEdit,
  },
  props: {
    datastoreDetail: {
      type: Object,
      require: true,
    },
  },
  data: (vm) => ({
    baseMaps: [],
  }),
  watch: {},
  computed: {
    ...mapGetters({
      currentId: 'auth/currentId',
      currentUser: 'auth/currentUser',
    }),
    api() {
      return API_FEATURE.updateOption({
        url: replaceLink(API_FEATURE.getUrl(), {
          id: this.datasetStoreDetailId,
        }),
      })
    },
  },
  created() {
    API_BASEMAP.list().then((res) => {
      this.baseMaps = res.data.map((x) => BaseMapCreate(x))
    })
  },
  mounted() {},
  methods: {
    onSelectMap(props) {
      this.$emit('click:select', props)
    },
    setHoverFeature(id, geometry) {
      if (this.$refs.DatastoreDetailControlEdit) {
        this.$refs.DatastoreDetailControlEdit.setHoverFeature(id, geometry)
      }
    },
    onReset() {
      if (this.$refs.DatastoreDetailControlEdit) {
        this.$refs.DatastoreDetailControlEdit.onReset()
      }
    },
  },
}
</script>
<style scoped></style>
